import * as React from "react";
import {useCensusListInfinite} from "../data/hooks/CensusCoolerHooks";
import {JSONCensus} from "../../processes/massive_actions/CensusCooler/data/models/JSONCensus";
import {useLocation} from "react-router-dom";

interface CensusListContextType {
    flattenedData: JSONCensus[],
    handleOnLoadNextPage: () => void,
    hasNextPage: boolean,
    isNextPageLoading: boolean,
    error: Error,
    totalCount: number,
    isFetching: boolean
}

export const CensusListContext = React.createContext<CensusListContextType>(
    {} as any,
);

type CensusListProps = {};


export const CensusListProvider: React.FC<CensusListProps> = ({
                                                                  children,
                                                              }) => {
    const [isFirstLoad, setIsFirstLoad] = React.useState<boolean>(true);

    const {
        flattenedData,
        handleOnLoadNextPage,
        hasNextPage,
        isNextPageLoading,
        error,
        totalCount,
        isFetching,
        mutate
    } = useCensusListInfinite({page: 0, size: 20});

    const location = useLocation()

    React.useEffect(() => {
        if (!isFirstLoad && location.pathname === "/") {
            mutate()
        } else {
            setIsFirstLoad(false)
        }
    }, [location]);

    return (
        <CensusListContext.Provider
            value={{
                flattenedData,
                handleOnLoadNextPage,
                hasNextPage,
                isNextPageLoading,
                error,
                totalCount,
                isFetching
            }}
        >
            {children}
        </CensusListContext.Provider>
    );
};
